export const LookupPlaceholders = {
    dashboard: "<Dashboard>",
    contactDetails: "<ContactDetails>",
    contactTimes: "<ContactTimes>",
    smartcard: "<SmartcardNumber>",
    customerCare: "<CustomerCare>",
    ussd: "<USSD>"
}

export default LookupPlaceholders;